import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { RpcInputOptions } from '@core-controls/components/rpc-input/models/rpc-input-options';
import { SimpleChanges } from '@core-models/utilities/generic-simple-changes';
import { ValidationService } from '@core-validation/validation.service';
import { MAXIMUM_MESSAGE_LENGTH } from './constants/invite-user-form.constants';
import { emailAvailableForInvitation } from './validators/email-available-for-invitation.validator';
import { RpcTextAreaOptions } from '@core-controls/components/rpc-textarea/models/rpc-text-area-options';
import { RpcInputComponent } from '../../../../../core-modules/controls/components/rpc-input/rpc-input.component';
import { RpcTextAreaComponent } from '../../../../../core-modules/controls/components/rpc-textarea/rpc-textarea.component';

@Component({
    selector: 'invite-user-form',
    templateUrl: './invite-user-form.component.html',
    styleUrls: ['./invite-user-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, ReactiveFormsModule, RpcInputComponent, RpcTextAreaComponent]
})
export class InviteUserFormComponent implements OnChanges {

    @Input() public email?: string;

    @Input() public portfolioEmails: string[] = [];

    public readonly maximumMessageLength = MAXIMUM_MESSAGE_LENGTH;
    public readonly inviteUserFormGroup: UntypedFormGroup = new UntypedFormGroup({});
    public recepientEmailControlOptions: RpcInputOptions;
    public commentOptions: RpcTextAreaOptions;

    constructor(
        private readonly validationService: ValidationService,
    ) { }

    public get recepientEmail(): string {
        return this.inviteUserFormGroup.get('recepientEmail')?.value as string;
    }

    public get message(): string {
        return this.inviteUserFormGroup.get('message')?.value as string;
    }

    public ngOnChanges(changes: SimpleChanges<InviteUserFormComponent>): void {
        const { email, portfolioEmails } = changes;

        if (portfolioEmails.currentValue != null) {
            this.initializeForm(portfolioEmails.currentValue, email.currentValue);
        }
    }

    private initializeForm(portfolioEmails: string[], email: string): void {
        this.recepientEmailControlOptions = {
            controlName: 'recepientEmail',
            formGroup: this.inviteUserFormGroup,
            defaultValue: email,
            validatorsMap: [
                {
                    message: 'INVITE_USER_FORM.ERRORS.EMAIL_REQUIRED',
                    showError: (control: UntypedFormControl) => control.hasError('required'),
                    validator: Validators.required
                },
                {
                    message: 'INVITE_USER_FORM.ERRORS.WRONG_EMAIL',
                    showError: (control: UntypedFormControl) => control.hasError('email'),
                    validator: this.validationService.emailWithDotValidator
                },
                {
                    message: 'PROFILE_COMMON.ERRORS.EMAIL_USED_BY_SAME_COMPANY_CUSTOMER',
                    showError: (control: UntypedFormControl) => control.hasError('unavailable'),
                    validator: emailAvailableForInvitation(portfolioEmails.filter(x => x !== email))
                }
            ]
        };

        this.commentOptions = {
            formGroup: this.inviteUserFormGroup,
            controlName: 'message',
            defaultValue: '',
            validatorsMap: [{ message: '', showError: (control: UntypedFormControl) => control.hasError('maxlength'), validator: Validators.maxLength(this.maximumMessageLength) }]
        };
    }
}
